export default __webpack_public_path__ + "static/media/audioToLetter.6e5119e5.png";